import {Component, Input, OnInit} from '@angular/core';
import {ProvinceDTO} from '../../../../shared/dto/province.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ProvinceService} from '../../../../shared/service/province.service';
import swal from "sweetalert2";
import {TokenStorageService} from '../../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-province-popup',
  templateUrl: './province-popup.component.html',
  styleUrls: ['./province-popup.component.scss']
})
export class ProvincePopupComponent implements OnInit {
  @Input() provinceMgtCopy_: ProvinceDTO[];
  public provinceMgt: any;
  public selectedState: string;
  ActionMode = ActionMode;
  public code: string;
  public description: string;
  public selectedMode;
  public provincePopup: FormGroup;
  public href: string = "";

  constructor(public activeModal: NgbActiveModal,
              public provinceService: ProvinceService,
              public tokenStorageService: TokenStorageService,
              private router : Router) { }

  ngOnInit() {
    this.provincePopup = new FormGroup({
      code: new FormControl(null,Validators.required),
      description: new FormControl(null,Validators.required),
      states: new FormControl(null,Validators.required),
    });
    this.href = this.router.url;
    this.provinceMgt = {...this.provinceMgtCopy_};
    if (this.selectedMode === ActionMode.VIEW) {
      this.provincePopup.disable();
    }
  }

  onSubmit(){
    let isValid: boolean = true;
    let errorMessage: string = '';

    // if (!this.employeePopup.valid) {
    //   isValid = false;
    //   errorMessage = 'Please, Fill the form Data...!'
    // }
    if (isValid) {
      swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result)=> {
        if(result.value) {
          const provinceDTO: ProvinceDTO = new ProvinceDTO(
            this.code,
            this.description,
            this.selectedState,
            this.tokenStorageService.getUserObjectToken().username,
            this.href
          );
          this.provinceService.saveProvince(provinceDTO).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.activeModal.close("Saved");
            }
          );
        }
        }, reason => {
        }
      );
    } else{
      swal.fire('Error',errorMessage,'error');
    }
  }
}
